module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', [(_vm.notExisted) ? _c('div', [_c('h2', [_vm._v("嗯，这个标签并不存在")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://as.bitinn.net/upload/cj2l8o36f00ofbo5nj7spml66.1200.jpg"
    }
  })]) : _c('div', [(_vm.tags) ? _c('div', {
    staticClass: "tags-container"
  }, _vm._l((_vm.tags), function(item) {
    return _c('span', {
      staticClass: "tag",
      class: {
        'active': _vm.tag === item.name
      },
      on: {
        "click": function($event) {
          _vm.fetchTag(item.name)
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])
  })) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('only-post', {
      key: post.title,
      staticClass: "animated",
      class: _vm.themeCfg.animated && _vm.themeCfg.animated.tags,
      attrs: {
        "post": post
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ccd2b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tags.vue
// module id = 167
// module chunks = 1